const ver = process.env.BUILD_DATE;

export const verQuery = `v=${ver}`;
export default ver;
